import './Achievements.css';

const Achievements = () => {
  return (
    <section className="how-it-works1 achievements">
      <div className="c-t-a-background2">
        <h1 className="experience-the-releva">Achievements & Recognition </h1>
        <div className="edge-connector">
          <div className="from-diverse-industries">Releva's global impact on eCommerce from around the world.</div>
        </div>
        <div className="frame-parent30">
          <img src="/HomePage/badges/recognitions/1.png" width="150" />
          <img src="/HomePage/badges/recognitions/2.png" width="150" />
          <img src="/HomePage/badges/recognitions/3.png" width="150" />
          <img src="/HomePage/badges/recognitions/4.png" width="150" />
          <img src="/HomePage/badges/recognitions/5.png" width="150" />
          <img src="/HomePage/badges/recognitions/6.png" width="150" />
        </div>
        <div className="frame-parent30"></div>
        <div className="frame-parent30">
          <img src="/HomePage/badges/E-Commerce_BestSupport_QualityOfSupport.png" width="150" />
          <img src="/HomePage/badges/E-Commerce_EasiestAdmin_EaseOfAdmin.png" width="150" />
          <img src="/HomePage/badges/E-Commerce_EasiestToDoBusinessWith_EaseOfDoingBusinessWith.png" width="150" />
          <img src="/HomePage/badges/E-Commerce_HighPerformer_HighPerformer.png" width="150" />
          <img src="/HomePage/badges/E-Commerce_UsersMostLikelyToRecommend_Nps.png" width="150" />
        </div>
        <div className="frame-parent30">
          <img src="/HomePage/badges/E-CommercePersonalization_BestSupport_QualityOfSupport.png" width="150" />
          <img
            src="/HomePage/badges/E-CommercePersonalization_BestSupport_Small-Business_QualityOfSupport.png"
            width="150"
          />
          <img src="/HomePage/badges/E-CommercePersonalization_EasiestAdmin_EaseOfAdmin.png" width="150" />
          <img
            src="/HomePage/badges/E-CommercePersonalization_EasiestAdmin_Small-Business_EaseOfAdmin.png"
            width="150"
          />
          <img
            src="/HomePage/badges/E-CommercePersonalization_EasiestToDoBusinessWith_EaseOfDoingBusinessWith.png"
            width="150"
          />
        </div>
        <div className="frame-parent30">
          <img
            src="/HomePage/badges/E-CommercePersonalization_EasiestToDoBusinessWith_Small-Business_EaseOfDoingBusinessWith.png"
            width="150"
          />
          <img src="/HomePage/badges/E-CommercePersonalization_HighPerformer_EMEA_HighPerformer.png" width="150" />
          <img src="/HomePage/badges/E-CommercePersonalization_HighPerformer_Europe_HighPerformer.png" width="150" />
          <img src="/HomePage/badges/E-CommercePersonalization_HighPerformer_HighPerformer.png" width="150" />
          <img
            src="/HomePage/badges/E-CommercePersonalization_HighPerformer_Small-Business_EMEA_HighPerformer.png"
            width="150"
          />
        </div>
        <div className="frame-parent30">
          <img
            src="/HomePage/badges/E-CommercePersonalization_HighPerformer_Small-Business_Europe_HighPerformer.png"
            width="150"
          />
          <img
            src="/HomePage/badges/E-CommercePersonalization_HighPerformer_Small-Business_HighPerformer.png"
            width="150"
          />
          <img src="/HomePage/badges/E-CommercePersonalization_UsersMostLikelyToRecommend_Nps.png" width="150" />
          <img
            src="/HomePage/badges/E-CommercePersonalization_UsersMostLikelyToRecommend_Small-Business_Nps.png"
            width="150"
          />
        </div>
      </div>
    </section>
  );
};

export default Achievements;
